import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./quote.m.css";
const QuoteBase = ({ element, template = "", elementAlignment, externalLink = false, index }) => {
  const supportedTemplates = {
    default: "",
    "quote-1": "wrapper--quote-1",
    "quote-2": "wrapper--quote-2"
  };
  const elementStyle = (template, elementAlignment, index) => {
    const isAlign = {
      0: {
        left: "left",
        right: "right"
      }
    };

    return get(isAlign, [index, elementAlignment], "");
  };

  const templateStyle = supportedTemplates[template] ? `card-content ${supportedTemplates[template]}` : `card-content `;

  const textQuote = get(element, ["metadata", "content"], "");
  const attribution = get(element, ["metadata", "attribution"]);

  let text = textQuote || "";
  if (externalLink) {
    text = textQuote.replace(/<a/g, '<a target="_blank"');
  }
  return (
    <div styleName={`${templateStyle} ${elementStyle(template, elementAlignment, index)}`}>
      <div styleName="line" />
      <p styleName="text" dangerouslySetInnerHTML={{ __html: text }} />
      <p styleName="attribution">{attribution}</p>
    </div>
  );
};

QuoteBase.propTypes = {
  element: PropTypes.object,
  template: PropTypes.object,
  elementAlignment: PropTypes.object,
  index: PropTypes.index,
  externalLink: PropTypes.bool
};

const mapStateToProps = state => ({
  template: get(state, ["qt", "config", "theme-attributes", "quote-element"], "default")
});

export const Quote = connect(mapStateToProps)(QuoteBase);
